@let s = homeState();
@if (s.kind === 'pending') {
  <div class="bg-slate-50 min-h-screen" aria-busy="true" aria-live="polite">
    <app-marketing-header variant="home" />
    <div class="cg-container--marketing flex flex-col items-center justify-center gap-4 py-24 text-slate-500">
      <span
        class="h-10 w-10 animate-spin rounded-full border-2 border-slate-300 border-t-slate-700"
        aria-hidden="true"
      ></span>
      <p class="text-sm">Loading…</p>
    </div>
  </div>
} @else if (s.kind === 'error') {
  <div class="cg-container--marketing py-16 text-center">
    <h1 class="text-xl font-semibold text-slate-800">Home page unavailable</h1>
    <p class="mt-3 max-w-lg mx-auto text-slate-600">
      The marketing API did not return home content. Ensure the API is running.
    </p>
    <a routerLink="/auth/login" class="cg-mkt-btn cg-mkt-btn--primary mt-6 inline-block">Admin login</a>
  </div>
} @else {
  <div class="bg-slate-50">
    <app-marketing-header variant="home" />
    <app-marketing-hero
      [hero]="{
        variant: 'home',
        badge: s.home.hero.badge,
        title: s.home.hero.title,
        lede: s.home.hero.lede,
        features: s.home.hero.features,
        primaryCta: s.home.hero.primaryCta,
        backgroundImage: s.home.hero.backgroundImage ?? s.home.hero.image,
        artImage: s.home.hero.artImage,
        gallery: s.home.hero.gallery,
        sideBadge: s.home.hero.sideBadge,
      }"
    />
    <app-marketing-stats-strip [stats]="s.home.stats" />
    <section class="h1-section h1-section--cool" id="destinations">
      <div class="h1-section__inner">
        <header class="h1-section__head">
          @if (s.home.destinations.eyebrow) {
            <span class="h1-eyebrow">{{ s.home.destinations.eyebrow }}</span>
          }
          @if (s.home.destinations.title) {
            <h2>{{ s.home.destinations.title }}</h2>
          }
          @if (s.home.destinations.subtitle) {
            <p>{{ s.home.destinations.subtitle }}</p>
          }
        </header>
        @if (s.home.destinations.countries.length) {
          <div class="h1-dest-grid">
            @for (c of s.home.destinations.countries; track c.slug) {
              <app-marketing-country-card [country]="c" />
            }
          </div>
        } @else {
          <p class="text-center text-slate-600">Featured destinations will appear here once configured in admin.</p>
        }
      </div>
    </section>
    <section class="h1-section h1-section--warm" id="global-success-stories">
      <div class="h1-section__inner">
        <header class="h1-section__head h1-section__head--center">
          <h2>{{ s.home.successStories.title ?? 'Global Success Stories' }}</h2>
          <p>
            {{
              s.home.successStories.subtitle
                ?? 'Real journeys, life-changing achievements, and global impact.'
            }}
          </p>
        </header>
        @if (successStoryItems(s.home).length) {
          <app-marketing-global-success-stories [stories]="successStoryItems(s.home)" />
        }
        @if (testimonialItems(s.home).length) {
          <app-marketing-testimonials [items]="testimonialItems(s.home)" />
        }
      </div>
    </section>
    <app-marketing-why-choose />
    <app-marketing-success-roadmap />
    <section class="cg-section" id="cta">
      <div class="cg-container--marketing">
        <app-marketing-consultation-cta
          [cta]="s.home.cta"
          [destinationOptions]="destinationNames(s.home)"
          sourcePage="/"
        />
      </div>
    </section>
    <app-marketing-footer />
    @if (s.home.popup?.image?.cdnUrl; as popupUrl) {
      <app-marketing-popup
        [imageUrl]="popupUrl"
        [imageAlt]="s.home.popup!.image.alt"
        [delaySeconds]="s.home.popup!.delaySeconds"
      />
    }
  </div>
}
